import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/stockloan",
    name: "introduceStoackLoan",
    component: () => import("@/components/pages/stockLoan/Introduce.vue"),
    meta: {
      layout: "common",
    },
  }, 
  {
    path: "/stockloan/checkCi",
    name: "brwrCheckCi",
    component: () => import("@/components/pages/stockLoan/brwrRegister/CheckCI.vue"),
    meta: {
      layout: "blank",
    },
  }, {
    path: "/stockloan/register/:step",
    name: "StockLoanBrwrRegister",
    component: () =>
      import(
        "@/components/pages/stockLoan/brwrRegister/StockBrwrRegisterView.vue"
      ),
    meta: {
      layout: "mobile-no-footer",
    },
  }, {
    path: "/stockloan/confirm",
    name: "StockLoanDocCheck",
    component: () =>
      import(
        "@/components/pages/stockLoan/DocCheckView.vue"
      ),
    meta: {
      layout: "mobile-no-footer",
    },
  }, {
    path: "/stockloan/brwrManageBlank",
    name: "manageStockLoan",
    component: () => import("@/components/pages/stockLoan/brwrManage/BrwrManageBlank.vue"),
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/stockloan/brwrManage",
    name: "stockLoanBrwrManage",
    component: () => import("@/components/pages/stockLoan/brwrManage/BrwrManage.vue"),
    meta: {
      layout: "brwr",
    },
  },
  {
    path: "/stockloan/checkBrwrCi",
    name: "brwrManageCheckCi",
    component: () => import("@/components/pages/stockLoan/brwrManage/CheckBrwrCI.vue"),
    meta: {
      layout: "blank",
    },
  },
  {
    path: "/stockloan/ivtrManageSample",
    name: "stockLoanIvtrManageSample",
    component: () => import("@/components/pages/stockLoan/ivtrManage/IvtrManageSample.vue"),
    meta: {
      layout: "brwr",
      
    },
  },
  {
    path: "/stockloan/ivtrManage",
    name: "stockLoanIvtrManage",
    component: () => import("@/components/pages/stockLoan/ivtrManage/IvtrManage.vue"),
    meta: {
      layout: "brwr",
      allowedManageType: ['STOCK'] 
    },
  },
  
];

export default routes;
